exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".source-logo-dashboard[data-v-493a40bd]{float:left;width:50px;height:50px;margin-right:5px;opacity:1}", ""]);

// exports
